<template>
  <div
    class="container"
    :class="{
      'container-offset': !menuInactive,
      'container-open': open,
    }"
  >
    <span class="buttons" :style="floatStyle">
      <Button
        class="button-pdf p-button-rounded p-shadow-5"
        @click="onExport('export-pdf')"
      >
        <IconPdf :width="27" :height="27"></IconPdf>
      </Button>
    </span>
    <span class="buttons" :style="floatStyle">
      <Button
        class="button-xlsx p-button-rounded p-shadow-5"
        @click="onExport('export-xlsx')"
      >
        <IconExcel :width="27" :height="27" :negative="true"></IconExcel>
      </Button>
    </span>
    <span class="buttons" :style="floatStyle">
      <Button
        class="button-csv p-button-rounded p-shadow-5"
        @click="onExport('export-csv')"
      >
        <IconCsv :width="27" :height="27"></IconCsv>
      </Button>
    </span>
    <span class="buttons">
      <Button
        class="button-print p-button-rounded p-shadow-5"
        :style="{ width: '56px', height: '56px' }"
        @click="onClickOpen()"
      >
        <IconPrint v-if="!loading" :width="45" :height="45"></IconPrint>
        <i v-else class="pi pi-spin pi-spinner" style="font-size: 25px"></i>
      </Button>
    </span>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import IconPrint from './icon/IconPrint';
import IconCsv from './icon/IconCsv';
import IconPdf from './icon/IconPdf';
import IconExcel from './icon/IconExcel.vue';

export default {
  name: 'AppButtonExport',
  components: {
    IconPrint,
    IconCsv,
    IconPdf,
    IconExcel,
  },
  props: {
    loading: Boolean,
  },
  computed: {
    ...mapFields('app', ['menuInactive']),
  },
  data() {
    return {
      open: false,
      floatStyle: 'display: none',
    };
  },
  methods: {
    onExport(format) {
      this.$emit(format);
      this.open = false;
    },
    onClickOpen() {
      const value = !this.open;
      if (value) {
        this.floatStyle = 'display: block';
      } else {
        this.floatStyle = 'display: none';
      }
      setTimeout(() => (this.open = value), 50);
    },
  },
};
</script>

<style scoped>
.container {
  width: 56px;
  position: fixed;
  bottom: 1em;
  left: 1em;
  z-index: 1000;
}

@media (min-width: 600px) {
  .container {
    left: 2em;
  }
}

.container-offset {
  left: 245px;
  transition: margin-left 0.2s;
  transition-property: margin-left;
  transition-duration: 0.2s;
  transition-timing-function: ease;
  transition-delay: 0s;
}

.container-open .buttons:not(:last-of-type) {
  width: 40px;
  height: 40px;
  margin: 15px auto 0;
  opacity: 1;
}

.button-print,
.button-print:hover {
  background-color: black !important;
  border-color: black !important;
}

.button-xlsx,
.button-xlsx:hover {
  background-color: #1e7145 !important;
  border-color: #1e7145 !important;
}

.button-csv,
.button-csv:hover {
  background-color: #868686 !important;
  border-color: #868686 !important;
}

.button-pdf,
.button-pdf:hover {
  background-color: #ff0000 !important;
  border-color: #ff0000 !important;
}

.button-pdf,
.button-xlsx,
.button-csv {
  width: 38px;
  height: 38px;
  padding: 7px;
}

.buttons {
  display: block;
  width: 35px;
  height: 35px;
  margin: 20px auto 0;
  position: relative;
  opacity: 0;
  transition: 0.2s;
}

.buttons:nth-last-of-type(2) {
  transition-delay: 20ms;
}

.buttons:nth-last-of-type(3) {
  transition-delay: 40ms;
}

.buttons:nth-last-of-type(1) {
  width: 56px;
  height: 56px;
  opacity: 1;
}
</style>
